import React from "react";
import classNames from "classnames";

import classes from "./classes.module.scss";
import Loader from "../Loader";
import { createIconButtonKeyDownHandler } from "./iconButtonAccessibilityHandlers";

export enum EIconButtonVariant {
	DEFAULT = "default",
	NEUTRAL = "neutral",
	PRIMARY = "primary",
	ERROR = "error",
	SUCCESS = "success",
	WARNING = "warning",
	INFO = "info",
}

type IconButtonInteractiveProps = {
	icon: React.ReactNode;
	onClick: React.MouseEventHandler<HTMLSpanElement>;
	/** Obligatoire dès qu'un clic est exposé (bouton icône seul). */
	ariaLabel: string;
	variant?: EIconButtonVariant;
	disabled?: boolean;
	loading?: boolean;
	className?: string;
};

type IconButtonStaticProps = {
	icon: React.ReactNode;
	onClick?: undefined;
	ariaLabel?: string;
	variant?: EIconButtonVariant;
	disabled?: boolean;
	loading?: boolean;
	className?: string;
};

type IProps = IconButtonInteractiveProps | IconButtonStaticProps;

export default function IconButton(props: IProps): React.JSX.Element {
	const { icon, onClick, className, variant = EIconButtonVariant.DEFAULT, disabled = false, loading = false, ariaLabel } = props;

	const isDisabled = disabled || loading;
	const rootClass = classNames(classes["root"], className, classes[variant], isDisabled && classes["disabled"]);
	const content = loading ? <Loader width="20px" /> : icon;

	if (isDisabled || !onClick) {
		return <span className={rootClass}>{content}</span>;
	}

	return (
		<span
			role="button"
			tabIndex={0}
			aria-label={ariaLabel}
			onKeyDown={createIconButtonKeyDownHandler(onClick)}
			onClick={onClick}
			className={rootClass}>
			{content}
		</span>
	);
}
